import { FC } from 'react';
import { container } from 'system/registry';
import { LoadingProvider } from 'application/contexts/useLoading';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { companyUserContext, useCompanyUser } from 'application/contexts/useCompanyUser';
import { companySupportChatContext, useCompanySupportChat } from 'application/contexts/useCompanySupportChat';
import { companyChatContext, useCompanyChat } from 'application/contexts/useCompanyChatRoom';
import { ScrollToTop } from 'ui/components/layouts/ScrollToTop';
import { LocationTracker } from 'application/hooks/useLocationTracker';
import { Outlet } from 'react-router-dom';

const CompanyContextConfig: FC = () => {
    return (
        <LoadingProvider>
            <LocationTracker />
            <ScrollToTop />
            <CompanyContexts />
        </LoadingProvider>
    );
};

const CompanyContexts: FC = () => {
    const companyUserCtx = useCompanyUser();
    const companyChatCtx = useCompanyChat();
    const companySupportChatCtx = useCompanySupportChat();
    return (
        <diContainerContext.Provider value={container}>
            <companyUserContext.Provider value={companyUserCtx}>
                <companyChatContext.Provider value={companyChatCtx}>
                    <companySupportChatContext.Provider value={companySupportChatCtx}>
                        <Outlet />
                    </companySupportChatContext.Provider>
                </companyChatContext.Provider>
            </companyUserContext.Provider>
        </diContainerContext.Provider>
    );
};

export default CompanyContextConfig;
